import { render, staticRenderFns } from "./azour.vue?vue&type=template&id=21e00700&"
import script from "./azour.vue?vue&type=script&lang=js&"
export * from "./azour.vue?vue&type=script&lang=js&"
import style0 from "./azour.vue?vue&type=style&index=0&id=21e00700&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports